// extracted by mini-css-extract-plugin
export default {"imageAndName":"BundleColorSection-imageAndName-h6Q"};